import Vue from "vue";
import Router from "vue-router";
import HomeView from "@/components/pages/HomeView";
import ConsultaLicencia from "@/components/pages/licencias/ConsultaLicencia";
import ConsultaLicenciaPersonal from "@/components/pages/licencias/ConsultaLicenciaPersonal";
import RegistrarLicenciaSolicitud from "@/components/pages/licencias/RegistrarLicenciaSolicitud";
import ConsultaSolicitud from "@/components/pages/solicitudes/ConsultaSolicitud";
import ConsultaSolicitudAltaMedica from "@/components/pages/solicitudes/ConsultaSolicitudAltaMedica";
import RegistrarSolicitud from "@/components/pages/solicitudes/RegistrarSolicitud";
import RegistrarSolicitudAltaMedica from "@/components/pages/solicitudes/RegistrarSolicitudAltaMedica";
import RegistrarSolicitudPersonal from "@/components/pages/solicitudes/RegistrarSolicitudPersonal";
import RecibirSolicitudForm from "@/components/pages/solicitudes/RecibirSolicitudForm";
import AltaMedicaSolicitudForm from "@/components/pages/solicitudes/AltaMedicaSolicitudForm";
import RechazarSolicitudForm from "@/components/pages/solicitudes/RechazarSolicitudForm";
import NoAutorizarSolicitudForm from "@/components/pages/solicitudes/NoAutorizarSolicitudForm";
import AgregarComentarioSolicitudForm from "@/components/pages/solicitudes/AgregarComentarioSolicitudForm";

import AgregarAdjuntoForm from "@/components/pages/solicitudes/AgregarAdjuntoForm";

import Configuracion from "@/components/pages/configuraciones/Configuracion";
import Login from "@/components/pages/Login";
import Eventos from "@/components/pages/configuraciones/Eventos";
import Establecimiento from "@/components/pages/configuraciones/Establecimiento";
import Cie10 from "@/components/pages/configuraciones/Cie10";

// Importamos subpaginas
import RegimenLicencia from "@/components/pages/configuraciones/RegimenLicencia";
import TipoLicencias from "@/components/pages/configuraciones/TipoLicencias";

import Reportes from "@/components/pages/reportes/Reportes";
import LicenciasByArticulo from "@/components/pages/reportes/LicenciasByArticulo";
import SolicitudesByEstado from "@/components/pages/reportes/SolicitudesByEstado";
import SolicitudesByNivel from "@/components/pages/reportes/SolicitudesByNivel";
import Personal from "@/components/pages/personal/Personal";
import NotFound from "@/components/pages/template/NotFound";

import UserStore from "@/store/";

Vue.use(Router);


const router = new Router({
  //mode: 'history',
  routes: [
    {
      path: "/",
      redirect: {
        name: "Login"
      }
    },

    {
      path: "/login",
      name: "Login",
      component: Login
    },

    {
      path: "/home",
      name: "home",
      component: HomeView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/registrarsolicitud',
      name: 'registrarsolicitud',
      component: RegistrarSolicitud,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/registrarsolicitudaltamedica',
      name: 'registrarsolicitudaltamedica',
      component: RegistrarSolicitudAltaMedica,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/registrarsolicitudpersonal',
      name: 'registrarsolicitudpersonal',
      component: RegistrarSolicitudPersonal,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/recibirsolicitudpersonal',
      name: 'recibirsolicitudpersonal',
      component: RecibirSolicitudForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/altamedicasolicitudpersonal',
      name: 'altamedicasolicitudpersonal',
      component: AltaMedicaSolicitudForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/agregarcomentariosolicitudpersonal',
      name: 'agregarcomentariosolicitudpersonal',
      component: AgregarComentarioSolicitudForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/rechazarsolicitudpersonal',
      name: 'rechazarsolicitudpersonal',
      component: RechazarSolicitudForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/noAutorizarSolicitudpersonal',
      name: 'noAutorizarSolicitudpersonal',
      component: NoAutorizarSolicitudForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/agregaradjunto',
      name: 'agregaradjunto',
      component: AgregarAdjuntoForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/registrarlicenciasolicitud/:solicitud_id",
      name: "registrarlicenciasolicitud",
      component: RegistrarLicenciaSolicitud,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/consultalicenciapersonal",
      name: "consultalicenciapersonal",
      component: ConsultaLicenciaPersonal,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/consultalicencia",
      name: "consultalicencia",
      component: ConsultaLicencia,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/consultasolicitudaltamedica",
      name: "consultasolicitudaltamedica",
      component: ConsultaSolicitudAltaMedica,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/consultasolicitud",
      name: "consultasolicitud",
      component: ConsultaSolicitud,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/establecimiento",
      name: "establecimiento",
      component: Establecimiento,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/configuracion",
      name: "configuracion",
      component: Configuracion,
      meta: {
        requiresAuth: true
      },
      children: [
        { path: "regimen", component: RegimenLicencia },
        { path: "tipo", component: TipoLicencias },
        { path: "cie10", component: Cie10 },
        { path: "eventos", component: Eventos }
      ]
    },
    {
      path: "/reportes",
      name: "reportes",
      component: Reportes,
      meta: {
        requiresAuth: true
      },
      children: [
        { path: "licenciasbyarticulo", component: LicenciasByArticulo },
        { path: "solicitudesbyestado", component: SolicitudesByEstado },
        { path: "solicitudesbynivel", component: SolicitudesByNivel }
      ]
    },
    {
      path: "/personal",
      name: "Personal",
      component: Personal,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/signout"
    },
    {
      path: "*",
      name: "NotFound",
      component: NotFound
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (UserStore.getters.isAuthenticated) {
    console.log("isAuthenticated if");
    const notValid = ["/login"];

    if (notValid.lastIndexOf(to.path) >= 0) {
      next({
        path: "/home"
      });
    } else if (to.path === "/signout") {
      UserStore.commit("removeAuthentication");
      next({
        path: "/"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log("requiresAuth");
    next({
      path: "/login",
      query: {
        redirect: to.fullPath
      }
    });
  } else if (to.path === "/signout") {
    next({
      path: "/"
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js